import React from "react";
import { connect } from "react-redux";
import Button from "../../../Button";
import FieldRow from "../../../FieldRow";
import { dialogAlert } from "../../../../actions/creators/dialogs";
import styled from "styled-components";
import { breakpoints } from "../../../../utils/styles";
import SidebarPanel from "../../../SidebarPanel";
import BodyBlocker from "../../../BodyBlocker";
import BackButton from "../../../common/BackButton";
import { validateEmail } from "../../../../utils/validation";
import { formatPhone } from "../../../../utils/strings";
import Submenu from "../../../common/Submenu";

const Container = styled.div`
    padding: var(--pad-x);
`;

const TypeSelector = styled.div`
    @media (min-width: ${breakpoints.desktop}px) {
        text-align: left;
    }
`;

interface Props {
    alert: (message: string) => void;
    onClose: () => void;
    onSubmit: (data: any) => void;
}

const WalletBuyGiftInfo: React.FC<Props> = ({ alert, onClose, onSubmit }) => {
    const [giftType, setGiftType] = React.useState<string>("email");
    const [giftFromName, setGiftFromName] = React.useState<string>("");
    const [giftToName, setGiftToName] = React.useState<string>("");
    const [giftToEmail, setGiftToEmail] = React.useState<string>("");
    const [giftToPhone, setGiftToPhone] = React.useState<string>("");
    const [giftMessage, setGiftMessage] = React.useState<string>("");

    function validateAndSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (!giftFromName) {
            alert("Por favor ingresa tu nombre");
            return;
        }
        
        if (!giftToName) {
            alert("Por favor ingresa el nombre del destinatario");
            return;
        }

        if (giftType === "email" && !validateEmail(giftToEmail)) {
            alert("Por favor ingresa un email válido");
            return;
        }

        if (giftType === "whatsapp" && !/^\d{10}$/.test(giftToPhone)) {
            alert("Por favor ingresa un número de WhatsApp válido");
            return;
        }

        if (!giftMessage) {
            alert("Por favor ingresa un mensaje");
            return;
        }

        onSubmit({ gift: giftType, giftFromName, giftToName, giftToEmail, giftToPhone, giftMessage });
    }

    return <>
        <BodyBlocker/>
        <SidebarPanel overBlocker>
            <Container>
                <BackButton label='' onBackClick={onClose}/>

                <p className="mt-5">
                    Ingresa ahora los datos de la persona a la que quieres enviarle la tarjeta y por dónde te gustaría mandar el regalo.
                </p>

                {/* <TypeSelector>
                    <Submenu
                        items={[
                            { id: "email", name: "Enviar por email" },
                            { id: "whatsapp", name: "Enviar por WhatsApp" }
                        ]}
                        selectedId={giftType}
                        onSelect={id => setGiftType(id as string)}
                    />
                </TypeSelector> */}
                
                <form onSubmit={validateAndSubmit}>
                    <FieldRow label="Tu nombre" required value={giftFromName} onChange={e => setGiftFromName(e.target.value)} />
                    <FieldRow label="Nombre del destinatario" required value={giftToName} onChange={e => setGiftToName(e.target.value)} />
                    {'email' === giftType && <FieldRow label="Email" type="email" required value={giftToEmail} onChange={e => setGiftToEmail(e.target.value)} />}
                    {'whatsapp' === giftType && <FieldRow label="Teléfono" type="number" maxLength={10} required value={giftToPhone} onChange={e => setGiftToPhone(formatPhone(e.target.value))} />}
                    <FieldRow label="Mensaje" type="textarea" required value={giftMessage} onChange={e => setGiftMessage(e.target.value)} /> 
                    
                    <Button primary submit>Continuar</Button>
                </form>
            </Container>
        </SidebarPanel>
    </>;
};

const mapDispatchToProps = {
    alert: (message: string) => dialogAlert(message),
};

export default connect(
    null,
    mapDispatchToProps
)(WalletBuyGiftInfo);